<template>
  <div v-if="hasMore" class="container-history">
    <button
      class="button-secondary button-small button-rounded"
      :disabled="loading"
      @click.prevent="fetchChatHistory(true)"
    >
      <IconSpinner v-if="loading" class="icon-spinner" />
      <span v-else>{{ t('view_previous_chats') }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';

import { fetchMessagesPastDm } from '@/api/apiService';
import IconSpinner from '@/components/icons/IconSpinner.vue';
import { useMessageStore } from '@/stores/message';
import { useSocketStore } from '@/stores/socket';

const loading = ref<boolean>(false);
const hasMore = ref<boolean>(false);
const nextOffset = ref(null);

const { t } = useI18n();

const socketStore = useSocketStore();
const messageStore = useMessageStore();

const chatId = computed<string>(() => {
  return socketStore.selectedChatId;
});

/**
 * @param save - 저장유무입니다.
 * 이전 대화 기록을 요청합니다.
 * */
const fetchChatHistory = async (save = false) => {
  if (loading.value) {
    return;
  }
  loading.value = true;
  const { data = { hasMore: false, nextOffset: null, datas: [] } } = await fetchMessagesPastDm(chatId.value);

  if (save) {
    hasMore.value = data.hasMore;
    nextOffset.value = data.nextOffset;
    messageStore.savePastMessage(data.datas, chatId.value);
  } else {
    hasMore.value = data.datas.length > 0;
  }

  loading.value = false;
};

onMounted(async () => {
  await fetchChatHistory();
});
</script>

<style scoped lang="scss">
.container-history {
  display: flex;
  justify-content: center;
  padding-top: 0.5rem;
}
</style>
